export const LOGIN = 'LOGIN';
export const RECOVER_PASSWORD = 'RECOVER_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const VERIFY_TOKEN = 'VERIFY_TOKEN';
export const CLEAR_AUTH = 'CLEAR_AUTH';
export const COMPLETE_INFO = 'COMPLETE_INFO';
export const UPDATE_INFO = 'UPDATE_INFO';
export const SET_COMPANY = 'SET_COMPANY';
export const SET_SUBCOMPANY = 'SET_SUBCOMPANY';
export const LOAD_SESSION = 'LOAD_SESSION';



// WEBPACK FOOTER //
// src/modules/auth/constants/auth_constants.js